import { responsive } from '@design-system/theme';
import { css } from 'styled-components';
import { ARROW_SIZE, POSITIONS } from '../constants';
export const getTrianglePosition = ({ parentHeight, parentWidth, theme, tooltipPosition, }) => {
    const heightMultiplied = parentHeight * 2;
    const widthDivided = parentWidth / 2;
    switch (tooltipPosition) {
        case POSITIONS.TOP:
            return css `
        transform: translate3d(-${ARROW_SIZE}px, 0, 0);
      `;
        case POSITIONS.RIGHT:
            return css `
        transform: translate3d(
          -50%,
          calc(${heightMultiplied}px - ${ARROW_SIZE}px),
          0
        );

        ${responsive('m') `
           transform: translate3d(calc(${widthDivided}px + ${ARROW_SIZE}px), calc(${parentHeight}px - 50%), 0);
         `}
      `;
        case POSITIONS.BOTTOM:
            return css `
        transform: translate3d(
          -50%,
          calc(${heightMultiplied}px - ${ARROW_SIZE}px),
          0
        );
      `;
        case POSITIONS['BOTTOM-RIGHT']:
            return css `
        transform: translate3d(
          -50%,
          calc(${heightMultiplied}px - ${ARROW_SIZE}px),
          0
        );

        ${responsive('m') `
           transform: translate3d(0, calc(${heightMultiplied}px - ${ARROW_SIZE}px), 0);
         `}
      `;
        case POSITIONS['TOP-RIGHT']:
            return css `
        transform: translate3d(-${ARROW_SIZE}px, 0, 0);
      `;
        case POSITIONS.LEFT:
            return css `
        transform: translate3d(
          -50%,
          calc(${heightMultiplied}px - ${ARROW_SIZE}px),
          0
        );

        ${responsive('m') `
           transform: translate3d(calc(-${widthDivided}px - ${theme.space[5]}px), calc(${parentHeight}px - 50%), 0);
         `}
      `;
        default:
            return '';
    }
};
//# sourceMappingURL=getTrianglePosition.js.map